export const colors = [
  '#FBF3DB',
  '#DDEDEA',
  '#DDEBF1',
  '#EAE4F2',
  '#F4DFEB',
  '#FBE4E4',
  '#EBECED',
  '#FAEBDD',
];
